// extracted by mini-css-extract-plugin
export default {"imgview":"Admin_imgview__V6E-k","bg":"Admin_bg__I0Ges"};